import { render, staticRenderFns } from "./lt-deposit-modal.vue?vue&type=template&id=00126409&scoped=true&"
import script from "./lt-deposit-modal.vue?vue&type=script&lang=js&"
export * from "./lt-deposit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00126409",
  null
  
)

export default component.exports